import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { Button, GmgTheme } from '@gmg/gmg-react-components';
import PageNotFoundLight from '../assets/svg/graphic_page-not-found_light.svg';
import PageNotFoundDark from '../assets/svg/graphic_page-not-found_dark.svg';
import EmptyPage from './shared/EmptyPage';
import { ROUTES } from 'src/routes';
import { useNavigate } from 'react-router-dom';


export const NotFoundPage = () => {
    const { t } = useTranslation();
    const theme = useTheme() as GmgTheme;
    const isDark = theme.type === 'dark';
    const navigate = useNavigate();
    const PageNotFound = isDark ? PageNotFoundDark : PageNotFoundLight;

    return (
        <EmptyPage
            image={<PageNotFound aria-label="404" width={255} height={255} />}
            title={t('NotFound.large_text', 'There is no light down here...')}
            description={t('NotFound.small_text', 'The page you are looking for cannot be found.')}
            button={<Button variant="primary" size='big' onClick={() => navigate(ROUTES.start)}>
                {t('NotFound.go_back_button', 'Return to main page')}
            </Button>}
            backgroundColor={theme.colors.backgroundPaper}
            fullScreen
        />
    );
};